import * as React from "react";

const data = {
  homeCarouselIndex: 0,
  setHomeCarouselIndex: (index: number) => {},
};

export const UiContext = React.createContext(data);
